import React from "react";
import NavBar from "../components/NavBar/NavBar";
import Footer from "../components/Footer/Footer";
import HeroTrain from "./HeroTrain/HeroTrain";

export default function Training() {
  return (
    <div>
      <NavBar />
      <HeroTrain />
      <Footer />
    </div>
  );
}
